export const FILESTACK_CDN = "https://cdn.filestackcontent.com/";
export const FILESTACK_TRANSFORM = "https://www.filepicker.io/api/file/";
export const OUTSCHOOL_CDN_PREFIX = "https://cdn.outschool";
export const OUTSCHOOL_CDN_DOMAINS = [
  "https://cdn.outschool.com/",
  "https://cdn.outschool.dev/",
];
export const OUTSCHOOL_FILESTACK_MIGRATION_PREFIX_WITH_SLASH =
  "outschool-filestack-migration/";
export const OUTSCHOOL_FILESTACK_GENERAL_PREFIX_WITH_SLASH =
  "outschool-filestack-general/";
export const OUTSCHOOL_FILESTACK_MIGRATION_PREFIX_WITHOUT_SLASH =
  "outschool-filestack-migration";
export const OUTSCHOOL_FILESTACK_GENERAL_PREFIX_WITHOUT_SLASH =
  "outschool-filestack-general";

export const STAGE_FILES_PREFIX_WITH_SLASH = "stage-files/";
export const STAGE_FILES_PREFIX_WITHOUT_SLASH = "stage-files";

export enum FileAccessTier {
  Public = "Public",
  Secured = "Secured",
}

/**
 * Returns the S3 bucket name based on the access tier.
 * @param accessTier The access tier (Public or Secured)
 * @param securedBucketName The name of the secured bucket (from environment variable OUTSCHOOL_SECURED_FILE_BUCKET)
 */
export function getBucketForAccessTier(
  accessTier: FileAccessTier,
  securedBucketName?: string | null,
): string {
  if (accessTier === FileAccessTier.Secured && !securedBucketName) {
    throw new Error("Secured bucket name is required for secured access tier");
  }

  return accessTier === FileAccessTier.Secured
    ? securedBucketName!
    : "outschool-filestack-general";
}
